import { useEffect } from 'react';

import { useFormikContext } from 'formik';

import { WebGameFormikModel } from '../models/web-game-formik.model';

export const useSyncGameFiles = (
  thumbnailFileId: number | null,
  zipFileId: number | null
) => {
  const { values, setValues, setFieldTouched } =
    useFormikContext<WebGameFormikModel>();

  useEffect(() => {
    if (values.zip != null) {
      setFieldTouched('zip', true, true);
    }
    if (values.thumbnail != null) {
      setFieldTouched('thumbnail', true, true);
    }

    if (values.zip !== zipFileId || values.thumbnail !== thumbnailFileId) {
      setValues(prev => ({
        ...prev,
        zip: zipFileId,
        thumbnail: thumbnailFileId,
      }));
    }
  }, [thumbnailFileId, zipFileId, values.zip, values.thumbnail]);
};
